<template>
    <div
        class="Game-layout relative bg-bg"
        :style="{
            '--safezone-top': safeZoneTop,
            '--safezone-bottom': safeZoneBottom,
            paddingTop: safeZoneTop,
        }"
        @click="handleTestAnnouncer"
    >
        <slot />
    </div>

    <GameExplanation />
</template>

<script>
import GameExplanation from '@/components/GameExplanations.vue'

export default {
    name: 'GameLayout',
    components: {
        GameExplanation,
    },
    computed: {
        safeZoneTop() {
            return (document.safeZone ? document.safeZone.top : 0) + 'px'
        },
        safeZoneBottom() {
            return (document.safeZone ? document.safeZone.bottom : 0) + 'px'
        },
    },
    methods: {
        handleTestAnnouncer(event) {
            if (event.ctrlKey) {
                console.log('GameLayout: Triggering test announcer event')
                this.$serviceBus.emit('announcer:speak', {
                    score: '1',
                    requiresPrefix: true,
                })
            }
        },
    },
}
</script>

<style lang="scss">
.Game-layout {
    width: 100vw;
    height: 100dvh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
</style>
